<template>
  <div id="wrap">
    <p class="title">Hi，留下宝贵意见，我们为你提供更好的服务～</p>
    <div class="wrap_h3"><span></span>问题描述（必填）</div>
    <el-input class="text" type="textarea" maxlength="200" resize="none" placeholder="输入详细描述（200字以内）"
      v-model="textarea">
    </el-input>
    <div class="wrap_h3"><span></span>问题截图（选填，最多3张）</div>
    <div class="photoWall">
      <ul class="imgList">
        <li @mouseleave="leave(index)" @mouseenter="enter(index)" @click="removeZ(index)"
          v-for="(item,index) in filePathList1" :key="index">
          <img :src="item" alt="">
          <span :class="{'delete':index == current}"></span>
        </li>

      </ul>
      <el-upload ref="upload" class="upload" action :http-request="uploadSectionFile" :before-upload="beforeUploadFile"
        list-type="picture-card" :on-change="handlePictureCardPreview" accept=".jpg,.jpeg,.png">
        <i class="el-icon-plus"></i>
      </el-upload>
    </div>
    <div class="btn">
      <el-button ref="btn" @click="submit">提交</el-button>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" top="40vh" width="20%">
      <span>确认删除该照片？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleZ">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  props: {

  },
  data () {
    return {
      textarea: '',//文本域
      dialogImageUrl: '',
      dialogVisible: false,
      fileArr: [],
      filePathList: [],//图片路径地址
      filePathList1: [],//图片路径地址
      formMovie: {},
      flag: false, //禁用
      current: null,
    };
  },
  methods: {
    //鼠标 有移除
    leave (index) {
      this.current = null
    },
    //移入显示遮罩层
    enter (index) {
      this.current = index
    },
    //删除照片
    deleZ () {
      let that = this
      this.filePathList1.splice(that.user_id, 1)
      this.filePathList.splice(that.user_id, 1)
      if (this.filePathList1.length < 3) {
        that.$refs.upload.$el.style.visibility = "visible";
      } else {
        that.$refs.upload.$el.style.visibility = "hidden";
      }
      this.dialogVisible = false
    },
    removeZ (id) {
      if (this.flag) {
        this.dialogVisible = false
        return
      }
      let that = this
      this.user_id = id
      this.dialogVisible = true
    },
    //提交
    submit () {
      let that = this
      if (that.textarea == "") {
        this.$message.closeAll();
        this.$message({
          message: '问题描述不能为空',
          type: 'warning'
        });
        return
      }

      let params = {
        content: that.textarea,
        feedBackUrl: that.filePathList.join(";")
      }
      const url = "/api/v1/userFeedback/insert"
      this.catReq1Service(url, params).then(function (response) {
        if (response.resultCode == "1") {
          that.$message({
            message: '已收到您的宝贵意见，谢谢~',
            type: 'success'
          });
          that.textarea = ""
          that.filePathList = []
          that.filePathList1 = []
          that.$refs.upload.$el.style.left = "170px"
          that.$refs.upload.$el.style.visibility = "visible";
        }

      })
    },
    //点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview (file, fileList) {

      // this.fileArr = fileList;
    },
    //上传前的校验
    beforeUploadFile (file) {
      var that = this;
      // let type = that.typeReg(file.name);
      let nameType = file.name.split(".");
      let type = nameType[nameType.length - 1];
      const isPNG = type === "png";
      const isJPG = type === "jpg";
      const isJPEG = type === "jpeg";
      if (!isPNG && !isJPG && !isJPEG) {
        alert("文件格式不支持")
        return false;
      }
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        alert("图片大小不能超过 20MB!")
        return false;
      }
    },
    // 上传函数——获取签名
    uploadSectionFile (param) {
      var that = this;
      var fileObj = param.file;
      var re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到后缀
        resultArr = re.exec(param.file.name);
      var type = resultArr[2];
      //自定义文件上传

      var url = "/api/v1/file/getUploadSign";
      var params = {
        fileType: "project"
      };
      this.catReq1Service(url, params).then(function (response) {
        if (!response.success) {
          return;
        }
        let data = response.result;
        that.host = data.host;
        var key = data.keyPrefix + "." + type;
        delete data.keyPrefix;
        delete data.host;
        that.formData = new FormData();
        that.formData.append("key", key);
        Object.keys(data).forEach(function (key) {
          // console.log(key, data[key]);
          that.formData.append(key, data[key]);
        });
        that.formData.append("file", fileObj);
        that.getFileHost(param);
      });
    },
    // 上传的第二个函数
    getFileHost (param) {
      var that = this;
      var FileController = that.host;
      var config = {
        onUploadProgress: progressEvent => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({
            percent: complete
          });
        }
      };
      axios
        .post(FileController, that.formData, config)
        .then(function (response) {
          if (!response) {
            return;
          }
          // that.dialogImageUrl = response.data.result.fileUrl;
          // that.dialogVisible = true
          that.filePathList.push(response.data.result.fileUrl);
          that.filePathList1.push(response.data.result.fileUrl);
          if (that.filePathList1) {
            that.$refs.upload.$el.style.left = "20px"
          }
          if (that.filePathList1.length >= 3) {
            that.$refs.upload.$el.style.visibility = "hidden";
          }
        });
    },
  },

};
</script>

<style lang="less" scoped>
#wrap {
  width: 77%;
  margin: 0 auto;
}
.title {
  text-align: left;
  position: relative;
  margin-top: 24px;
}
.wrap_h3 {
  margin-top: 24px;
  margin-bottom: 15px;
  text-align: left;
  font-weight: 900;
  display: flex;
  align-items: center;
}
.wrap_h3 span {
  display: block;
  float: left;
  width: 4px;
  height: 16px;
  background: #1e86e6;
  margin-right: 5px;
}
/deep/.el-textarea__inner {
  width: 758px;
  height: 225px;
}

.btn {
  /deep/.el-button {
    margin: 0 auto;
    margin-top: 60px;
    width: 86px;
    height: 39px;
    background-color: #1e86e6;
    color: white;
  }
}
/deep/.el-upload-list--picture-card {
  display: none;
}
.photoWall {
  display: flex;
}
.imgList {
  float: left;
  li {
    position: relative;
    float: left;
  }
  img {
    width: 150px;
    height: 150px;
    margin-right: 20px;
  }
  span {
    cursor: pointer;
  }
  .delete {
    opacity: 0.7;
    position: absolute;
    left: 0;
    top: 0;
    display: inline-block;
    width: 150px;
    height: 150px;
    background-image: url("../assets/imgs/delete_pictures.png");
  }
}
/deep/.el-dialog__footer {
  text-align: center;
}
</style>
